import React from 'react';
import './Hyperlink.scss';

function Hyperlink({ hyperlinkData, origin }) {
  return (
    <a
      className={origin ? `hyperlink hyperlink--${origin}` : 'hyperlink'}
      href={hyperlinkData.href}
      target="_blank"
      rel="noreferrer"
    >
      {hyperlinkData.copy}
    </a>
  );
}

export default Hyperlink;
